import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">Harnessing Tools for Research</h3>
      <p className="chapter__paragraph">
        “Time is really critical for a lot of wildlife species globally,” according to Dr. Hogg.
        “But it’s particularly important for a lot of our species here in Australia.”
      </p>
      <p className="chapter__paragraph">
        For the Threatened Species Initiative (TSI), Dr. Hogg’s team collects data on threatened
        species living in zoos, conservation sanctuaries, and threatened habitats. To do this, the
        team collects and collates samples, extracts DNA/RNA, and sequences genes. Conservation
        managers and scientists then use the data to boost the genetic diversity of threatened
        species. The more genetic diversity a species has, the greater capacity they have to adapt
        to a changing environment.
      </p>
    </section>
  );
}

export default Chapter2;
